<template>
  <div>
    <div :style="{textAlign: 'center', padding:'40px 0'}" v-if="step==1">
      <div :style="{fontSize: '20px'}">请选择时间: </div>
      <DatePicker :value="this.params.year + '-' + this.params.month" type="month" placeholder="请选择年月" style="width: 200px" @on-change="timeChange"></DatePicker>&nbsp;
        <Select clearable v-model="params.department_id" placeholder="选择部门" style="width:100px;text-align:left">
            <Option v-for="item in $store.state.department" :key="item.value" :value="item.value">{{item.label}}</Option>
        </Select>&nbsp;
      <Button @click="fetchData">确定</Button>
    </div>
    <div v-if="step==2" style="font-size:18px;text-align:center;padding: 40px 0">
      正在请求初始数据，请稍等...
    </div>
    <div style="text-align:center;padding: 0 0 10px" v-if="step==3">
      <span style="font-size:16px;">{{params.year}} 年 {{params.month}} 月</span>
      <a href="javascript:void(0);" @click="step=1">重选日期</a>
    </div>
    <div class="ivu-table-wrapper" v-if="step==3">
      <div class="ivu-table ivu-table-border ivu-table-stripe" style="overflow-x:scroll">
          <table cellspacing="0" cellpadding="0" border="0" style="width: 1651px;">
            <colgroup><col width="140"><col width="100"><col width="110"><col width="100"><col width="100"><col width="100"><col width="120"><col width="100"><col width="100"><col width="110"><col width="100"><col width="220"><col width="120">
            </colgroup>
            <thead>
              <tr>
                <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">负责人</span></div></th> -->
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目名称</span></div></th>
                <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目地</span></div></th> -->
                <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">月份</span></div></th> -->
                <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">收入</span></div></th>
                <th colspan="5" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目执行费用</span></div></th>
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目借款</span></div></th>
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">累计垫资</span></div></th>
                <!-- <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">{{'2-'+(params.month<=2?params.month:Number(params.month)-1)+'月总成本'}}</span></div></th> -->
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">本月回款</span></div></th>
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><Tooltip content="(人工成本+负责人差旅+人员租赁费用+项目借款+前几月总成本-本月回款)*0.008">垫资成本</Tooltip></div></th>
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目总成本(小计1+垫资成本)</span></div></th>
                <th colspan="1" rowspan="2" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">操作</span></div></th>
              </tr>
              <tr>
                <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">产值预估</span></div></th>
                <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">项目报销</span></div></th>
                 <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">人工成本</span></div></th>
                 <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">负责人差旅</span></div></th>
                 <th colspan="1" rowspan="1" class="ivu-table-column-center"><div class="ivu-table-cell"><span class="">人员租赁费用</span></div></th>
                 <th colspan="1" rowspan="1" class="ivu-table-column-center" style="background:#fbe8cb"><div class="ivu-table-cell"><span class="">小计</span></div></th>
               </tr>
             </thead>
             <tbody class="ivu-table-tbody">
               <template v-for="item in results">
                 <template  v-if="results && item.projects.length>0">
                 <!-- <tr class="ivu-table-row">
                    <td class="ivu-table-column-center" :rowspan="item.project.length==0?1:item.project.length"><div class="ivu-table-cell"><span>{{item.name}}</span></div></td>
                    <td class="ivu-table-column-center" :rowspan="item.project.length==0?1:item.project.length"><div class="ivu-table-cell"><span>{{item.director.username||'--'}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].project}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].address}}</span></div></td>
                    <td class="ivu-table-column-center" :rowspan="item.project.length==0?1:item.project.length"><div class="ivu-table-cell"><span>{{item.time}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].expected|toFixed}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].expense_count|toFixed}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{item.project[0].salary_count|toFixed}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{(item.project[0].expense_count + item.project[0].salary_count)|toFixed}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td>
                  </tr> -->
                  <tr class="ivu-table-row" v-for="(pro, ind) in item.projects" :key="item.id+'_'+ind">
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span>{{pro.name}}</span></div></td>
                    <!-- <td class="ivu-table-column-center"><div class="ivu-table-cell"><span></span></div></td> -->
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.output_value.value" placeholder="产值预估"/></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.expense_count" placeholder="项目报销"/></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.salary_count" placeholder="人工成本"/></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.travel_expenses" placeholder="负责人差旅"/></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.rental_cost" placeholder="人员租赁费用"/></span></div></td>
                    <td class="ivu-table-column-center" style="background:#fbe8cb"><div class="ivu-table-cell"><span>{{(Number(pro.expense_count) + Number(pro.salary_count) + Number(pro.travel_expenses) + Number(pro.rental_cost))|toFixed}}</span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.project_loan" placeholder="项目借款"/></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.previous_cost" placeholder="累计垫资"/></span></div></td>
                    <td class="ivu-table-column-center"><div class="ivu-table-cell"><span><Input v-model="pro.money_back" placeholder="本月回款"/></span></div></td>
                    <td class="ivu-table-column-center">
                      <div class="ivu-table-cell" >
                        <span v-text="countCost(pro)"></span>
                      </div>
                    </td>
                    <td class="ivu-table-column-center">
                      <div class="ivu-table-cell">
                        <span v-text="allCost(pro)"></span>
                      </div>
                    </td>
                    <td>
                      <div class="ivu-table-cell center">
                        <Tag type="border" :color="pro.status=='success'?'green':'red'" v-if="pro.status!=''">
                          <Icon type="ios-checkmark-empty" v-if="pro.status=='success'"></Icon>
                          <Icon type="ios-close-empty" v-else></Icon>
                          {{pro.message}}
                        </Tag>
                        <Button :type="pro.status==''?'primary':''" v-if="pro.status=='error'||pro.status==''" size="small" @click="submit(pro)">提交</Button>
                        <Button :type="pro.status==''?'primary':''" v-if="pro.status=='warning'" size="small" @click="submitReplace(pro)">覆盖</Button>
                        <!-- <Button type="default" size="small" @click="removeRow(pro, index)"><Icon type="close" /> 移除</Button> -->
                      </div>
                    </td>
                  </tr>
                 </template>
                </template>
              </tbody>
           </table>
       </div>
       <!-- <div style="padding:20px" v-if="step==3"> -->
         <!-- <Button type="primary">确定</Button>  -->
       <!-- </div> -->
     </div>
   </div>
</template>

<script>
import {post, fetch} from '../fetch/api'

export default {
  name: 'AnalysisForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rpId: {
      type: Number,
      default: 0
    },
    refresh: {
      type: Function
    },
    department: String,
    year: String,
    month: String
  },
  data () {
    return {
      step: 1,
      params: {
        year: '',
        month: '',
        department_id: null
      },
      results: []
    }
  },
  watch: {
  },
  filters: {
    toFixed (v) {
      return Number(v).toFixed(2)
    }
  },
  mounted () {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    this.params.year = year
    this.params.month = month <= 9 ? ('0' + month) : month
    // console.log(this.params.year, this.params.month)
  },
  methods: {
    timeChange (value) {
      let date = value.split('-')
      this.params = {
        year: date[0],
        month: date[1]
      }
      this.step = 2
      setTimeout(() => {
        this.fetchData()
      }, 2000)
    },
    fetchData () {
      fetch('business/analysis/init', {params: this.params}).then(res => {
        this.step = 3
        this.results = res
        this.spinShow = false
      })
    },
    removeRow (row, index) {
      const ind = this.results[index].project.indexOf(row)
      this.results[index].project.splice(ind, 1)
    },
    countCost (pro) {
      let count = (Number(pro.salary_count) + Number(pro.travel_expenses) + Number(pro.rental_cost) + Number(pro.project_loan) + Number(pro.previous_cost) - Number(pro.money_back)) * 0.008
      pro.cost = Number(count).toFixed(2)
      return Number(count).toFixed(2)
    },
    allCost (pro) {
      pro.all_cost = Number(Number(pro.expense_count) + Number(pro.salary_count) + Number(pro.cost) + Number(pro.travel_expenses) + Number(pro.rental_cost)).toFixed(2)
      return pro.all_cost
    },
    submit (pro) {
      pro.year = this.params.year
      pro.month = this.params.month
      pro.replace = 0
      post(`business/analysis`, pro).then(res => {
        pro.status = res.status
        pro.message = res.message
        if (res.status === 'success') {
          typeof this.refresh === 'function' && this.refresh()
        } else {
          this.$Notice.error({title: res.message})
        }
      })
      this.show = false
    },
    submitReplace (pro) {
      pro.year = this.params.year
      pro.month = this.params.month
      pro.replace = 1
      post(`business/analysis`, pro).then(res => {
        pro.status = res.status
        pro.message = res.message
        if (res.status === 'success') {
          typeof this.refresh === 'function' && this.refresh()
        } else {
          this.$Notice.error({title: res.message})
        }
      })
      this.show = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mgui-alert{
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1010
  }
  .mgui-alert-inner{
    width: 200px;
    position: absolute;
    top: 0;
    right: 0;
    z-index:1011;
  }
  .mgui-alert-item{
    width: 200px;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    position: relative;
    right: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4)
  }
  .mgui-alert-item h2{
    font-size: 12px;
    color: #f00;
    margin-bottom: 5px;
  }
  .mgui-alert-item p{
    font-size: 14px;
    margin: 0;
  }
  .mgui-alert-item {
    transition: all 1s;
    display: block;
    margin-bottom: 10px;
  }
  .mgui-alert-enter, .mgui-alert-leave-to
  /* .mgui-alert-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(100%);
  }
  .mgui-alert-leave-active {
    position: absolute;
  }

  .mgui-alert-close{
    position: absolute;
    right: 10px;
    top: 10px;
    transition: .5s 0s all ease;
    -webkit-transition: .5s 0s all ease;
  }
  .mgui-alert-close:hover{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  /*.bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }*/
</style>
